import * as Scrivito from "scrivito";
import React, { memo } from "react";
import cx from "classnames";
import type { NodeApi } from "@hogartrabe/react-arborist-vrh";
import { getHomepage } from "utils";
import type { Node } from "interfaces/schemas";

type WizardLinkComponentProps = {
  node: NodeApi<Node>;
  params: { nodeId: string; projectId: string };
  text: string | React.JSX.Element;
  disabled: boolean;
  handleToggleNodeActiveStatus: () => void;
};

const WizardLinkComponent = Scrivito.connect(
  ({
    node,
    params,
    text,
    disabled,
    handleToggleNodeActiveStatus,
  }: WizardLinkComponentProps) => {
    const homepage = getHomepage();
    const configWizardObjRefs = homepage?.get(
      "configWizardObjRefs",
    ) as Scrivito.Obj[];

    return (
      <Scrivito.LinkTag
        onClick={() => {
          if (!disabled && homepage) {
            Scrivito.navigateTo(configWizardObjRefs?.[1], {
              params,
            });
          }

          const nodeIsActive = node?.data.active;
          if (
            !nodeIsActive &&
            typeof handleToggleNodeActiveStatus === "function"
          ) {
            handleToggleNodeActiveStatus();
          }
        }}
        className={cx("ms-2", { "cursor-not-allowed": disabled })}
        id={`project-structure-wizard-link-${node?.id}`}
      >
        {text}
      </Scrivito.LinkTag>
    );
  },
);

export const WizardLink = memo(
  ({
    node,
    params,
    text,
    disabled,
    handleToggleNodeActiveStatus,
  }: WizardLinkComponentProps) => (
    <WizardLinkComponent
      node={node}
      params={params}
      text={text}
      disabled={disabled}
      handleToggleNodeActiveStatus={handleToggleNodeActiveStatus}
    />
  ),
);
